<ng-container *ngFor="let erpPromo of erpPromotionalTexts">
  <span *ngIf="erpPromo && erpPromo !== ''">
    {{ erpPromo }}
  </span>
</ng-container>
